import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import SiteNotificationsPage from "./NotificationBars/SiteNotifications/SiteNotificationsPage";

const OtherContentPage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/site-notifications`}>
                <SiteNotificationsPage />
            </Route> 
        </div>
    );
};

export default OtherContentPage;